export class ImageService {
    static getImageSource(base64String: Uint8Array): string {
        return `data:image/jpeg;base64,${base64String}`
    }
}